import React, {useState} from 'react'
import AudioRecorder from '../../survey-tools/audio-recorder'
import ThinkAloudDisplay from './think-aloud-display'
import ThinkAloudInstructions from './think-aloud-instructions'


const thinkAloudTimeLimit = 600 //in seconds

const RecordPage = <AudioRecorder timeLimit={thinkAloudTimeLimit}>
    <ThinkAloudDisplay/>
</AudioRecorder>


export default function ThinkAloudTask(props) {
    const [didInstructions, setDidInstructions] = useState(false)
    if (!didInstructions) {
            return <ThinkAloudInstructions
                finishInstructions={() => setDidInstructions(true)}/>
    } else {
            return RecordPage
    }
}